import { DataTableColumnHeader } from "@/shared/components/table";
import { Checkbox } from "@/shared/components/ui/checkbox";
import type { ColumnDef } from "@tanstack/react-table";
import { useMemo } from "react";
import type { UniversalThrottlingPolicy } from "../types/preferences_types";

export function useUniversalThrottlingColumns() {
    return useMemo<ColumnDef<UniversalThrottlingPolicy>[]>(
        () => [
            {
                id: "select",
                header: ({ table }) => (
                    <Checkbox
                        checked={table.getIsAllPageRowsSelected() || (table.getIsSomePageRowsSelected() && "indeterminate")}
                        onCheckedChange={(v) => table.toggleAllPageRowsSelected(!!v)}
                        aria-label="Select all"
                    />
                ),
                cell: ({ row }) => (
                    <Checkbox
                        checked={row.getIsSelected()}
                        onCheckedChange={(v) => row.toggleSelected(!!v)}
                        aria-label="Select row"
                        onClick={(e) => e.stopPropagation()}
                    />
                ),
                size: 50,
                minSize: 50,
                maxSize: 50,
                enableSorting: false,
                enableHiding: false,
                enableResizing: false,
            },
            { accessorKey: "id", header: ({ column }) => <DataTableColumnHeader column={column} title="ID" /> },
            { accessorKey: "channel", header: ({ column }) => <DataTableColumnHeader column={column} title="채널" /> },
            {
                accessorKey: "throttlingKey",
                header: ({ column }) => <DataTableColumnHeader column={column} title="스로틀링 키" />,
            },
            {
                accessorKey: "throttlingMethod",
                header: ({ column }) => <DataTableColumnHeader column={column} title="스로틀링 메서드" />,
                cell: ({ row }) => <pre className="max-w-[520px] whitespace-pre-wrap break-words text-xs">
                    {JSON.stringify(row.original.throttlingMethod, null, 2)}
                </pre>,
            },
        ],
        []
    );
}